import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ErrorAlert } from '@/components/shared/ErrorAlert';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';
import { TwoFactorVerify } from '@/components/auth/TwoFactorVerify';
export const LoginPage = () => {
    const navigate = useNavigate();
    const { login, complete2FALogin } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [requires2FA, setRequires2FA] = useState(false);
    const [userId, setUserId] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            const result = await login(email, password);
            if (result.requires2FA && result.userId) {
                setRequires2FA(true);
                setUserId(result.userId);
            }
            else {
                navigate('/');
            }
        }
        catch (err) {
            setError(err instanceof Error ? err.message : 'Invalid email or password. Please try again.');
        }
        finally {
            setIsLoading(false);
        }
    };
    const handle2FAVerify = async (token) => {
        await complete2FALogin(userId, token);
        navigate('/');
    };
    const handleBack = () => {
        setRequires2FA(false);
        setUserId('');
        setPassword('');
    };
    return (_jsx("div", { className: "min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-100", children: _jsx("div", { className: "max-w-md w-full mx-4", children: _jsx("div", { className: "card p-8", children: requires2FA ? (_jsx(TwoFactorVerify, { onVerify: handle2FAVerify, onBack: handleBack })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: "text-center mb-8", children: _jsx("h1", { className: "text-3xl font-bold text-gray-900", children: "Sign In" }) }), error && (_jsx("div", { className: "mb-6", children: _jsx(ErrorAlert, { message: error, onDismiss: () => setError('') }) })), _jsxs("form", { onSubmit: handleSubmit, className: "space-y-6", children: [_jsxs("div", { children: [_jsx("label", { htmlFor: "email", className: "block text-sm font-medium text-gray-700 mb-1", children: "Email" }), _jsx("input", { id: "email", type: "email", value: email, onChange: (e) => setEmail(e.target.value), required: true, autoComplete: "email", className: "input", placeholder: "", disabled: isLoading })] }), _jsxs("div", { children: [_jsx("label", { htmlFor: "password", className: "block text-sm font-medium text-gray-700 mb-1", children: "Password" }), _jsx("input", { id: "password", type: "password", value: password, onChange: (e) => setPassword(e.target.value), required: true, autoComplete: "current-password", className: "input", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", disabled: isLoading })] }), _jsx("button", { type: "submit", disabled: isLoading, className: "w-full btn-primary flex items-center justify-center", children: isLoading ? _jsx(LoadingSpinner, { size: "sm", className: "text-white" }) : 'Sign In' })] })] })) }) }) }));
};
